const IntervalUtil = () => {
  let timer = null

  const _get = () => {
    return timer
  }

  const _set = (callback, interval = 50) => {
    if (
      timer === null &&
      typeof callback === 'function'
    ) {
      timer = setInterval(callback, interval)
    }
  }

  const _clear = () => {
    if (
      timer !== null
    ) {
      clearInterval(timer)
      timer = null
    }
  }

  return {
    get: _get,
    set: _set,
    clear: _clear
  }
}

const TimeoutUtil = () => {
  let timer = null

  const _get = () => {
    return timer
  }

  const _clear = () => {
    if (
      timer !== null
    ) {
      clearTimeout(timer)
      timer = null
    }
  }

  const _set = (callback, timeout = 50) => {
    if (
      timer === null &&
      typeof callback === 'function'
    ) {
      timer = setTimeout(() => {
        callback.call()
        _clear()
      }, timeout)
    }
  }

  return {
    get: _get,
    set: _set,
    clear: _clear
  }
}

export {
  IntervalUtil,
  TimeoutUtil
}
